import script from "./DocumentAnnotator.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentAnnotator.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentAnnotator.vue?vue&type=style&index=0&id=63751738&scoped=true&lang=css"
import "./DocumentAnnotator.vue?vue&type=style&index=1&id=63751738&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63751738"]])

export default __exports__